import React from 'react'
import { Row, Col } from 'antd'
import PropTypes from 'prop-types'
// import { useAsync } from 'react-use'
import {
  Form,
  TextInput,
  SubmitButton,
  // SelectInput,
} from '@components/Form'
import { useLocalization } from '@contexts/LocalizationContext'
import validationSchema from './validationSchema'
// import { client } from '@utils/client'

const FormComponent = ({ handleSubmit, defaultValues = {} }) => {
  const { t } = useLocalization()
  const formItemLayout = {
    labelAlign: 'left',
  }
  return (
    <Form
      defaultValues={defaultValues}
      onSubmit={handleSubmit}
      validationSchema={validationSchema(t)}
    >
      <Row>
        <Col flex="auto">
          <TextInput
            name="url"
            label={t('article.form.label.url')}
            formItemOptions={{ formItemLayout }}
            defaultValue={defaultValues.url}
          />
          <TextInput
            name="urlEn"
            label={t('article.form.label.urlEn')}
            formItemOptions={{ formItemLayout }}
            defaultValue={defaultValues.urlEn}
          />
          {/* <SelectInput
            name="type"
            label={t('article.form.label.checklist')}
            options={options}
            formItemOptions={{
              formItemLayout: {
                labelAlign: 'left',
                labelCol: {
                  sm: { span: 1 },
                },
                wrapperCol: {
                  sm: { span: 3 },
                },
                style: {
                  flexDirection: 'column',
                },
              },
            }}
            onSelect={changeType}
            // mode="multiple"
            allowClear
          />
          <SelectInput
            name="version"
            value={version}
            label={t('article.form.label.version')}
            options={(state.value || []).map((item) => ({
              label: item,
              value: item,
            }))}
            formItemOptions={{
              formItemLayout: {
                labelAlign: 'left',
                labelCol: {
                  sm: { span: 1 },
                },
                wrapperCol: {
                  sm: { span: 3 },
                },
                style: {
                  flexDirection: 'column',
                },
              },
            }}
            onSelect={changeVersion}
            // mode="multiple"
            allowClear
          />
          <SelectInput
            name="checklist"
            label={t('article.form.label.checklist')}
            options={(stateChecklist.value || []).map((item) => ({
              label: item.title,
              value: item.id,
            }))}
            formItemOptions={{
              formItemLayout: {
                labelAlign: 'left',
              },
            }}
            mode="multiple"
            allowClear
          /> */}
          <SubmitButton formItemOptions={{ formItemLayout }}>
            {t('hospital.form.saveButton')}
          </SubmitButton>
        </Col>
      </Row>
    </Form>
  )
}
FormComponent.propTypes = {
  handleSubmit: PropTypes.func,
  defaultValues: PropTypes.object,
}

export default FormComponent
